import React from 'react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Step, StepLabel, Stepper, StepConnector } from '@mui/material';
import { styled } from '@mui/material/styles';
import Text from '../custom-text/custom-text.jsx';

import './custom-stepper.scss';

const CustomStepIcon = props => {
  const { active, completed } = props;

  return (
    <>
      {completed && (
        <FontAwesomeIcon
          icon={faCircleCheck}
          color={'#6E80F7'}
          fontSize={'19px'}
        />
      )}
      {active && <div className="active-step-icon">&nbsp;</div>}
      {!completed && !active && (
        <div className="uncompleted-step-icon">&nbsp;</div>
      )}
    </>
  );
};

const CustomStepConnector = styled(StepConnector)(() => ({
  top: 8,
  left: 'calc(-50% + 9px)',
  right: 'calc(50% + 9px)',
  '& .MuiStepConnector-line': {
    borderColor: '#6E80F7',
    borderWidth: 2,
  },
}));

const CustomStepper = ({ steps = [], activeStep, style }) => {
  return (
    <Box sx={style}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<CustomStepConnector />}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={CustomStepIcon}>
              <Text
                as="span"
                variant="bb1"
                color={activeStep >= index ? '#6E80F7' : '#6B7280'}
              >
                {label}
              </Text>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomStepper;
